import { RG_TYPE as t } from "@project-rouge/rg-core";
const o = (r) => {
  if (r.type !== t.Core)
    return !1;
  const e = r.data.hasFireLift;
  return e !== void 0 && e === !0;
};
export {
  o as isFireCore
};
//# sourceMappingURL=index4.js.map
